/**
 * 直播间报表
 */

import { HTTP_ALB, HTTP_YAF} from '../axios'
// 应用自定义字段
export const postApplyField = params => {
  return HTTP_ALB.post('/system/column/save', params)
}

// 获取自定义字段
export const getCustomField = params => {
  return HTTP_ALB.get('/system/column/get', params)
}
//  直播间报表列表
export const getliveappdata = params => {
  return HTTP_ALB.get('/data/live/app_data', params)
}

//  直播间场次报表列表
export const getlivelivedata = params => {
  return HTTP_ALB.get('/data/live/live_data', params)
}


// 主播报表
export const anchordata = params => {
  return HTTP_ALB.get('/data/staff/data', params)
}

// 主播结算报表
export const anchorSettledata = params => {
  return HTTP_ALB.post('/data/anchor/settle', params)
}
// 主播报表  导出
export const getDataStaffExport = (params, type) => {
  return HTTP_ALB.get('/data/staff/export', params, type)
}

// 主播报表  导出新
export const getDataAnchorExport = (params, type) => {
  return HTTP_ALB.post('/data/anchor/export', params, type)
}

// 直播间数据导出
export const getDataLiveExport = (params, type) => {
  return HTTP_ALB.post('/data/live/export', params, type)
}

// 主播-场次详情报表
export const anchorlivedata = params => {
  return HTTP_ALB.get('/data/staff/live', params)
}

// 主播-日详情报表
export const anchordaydata = params => {
  return HTTP_ALB.get('/data/staff/day', params)
}

//副播违规记录
export const recordList = params => {
  return HTTP_ALB.get('control/offense/list', params)
}


////主副播打卡记录
export const cardListData = params => {
  return HTTP_ALB.get('data/staff/clock', params)
}

//
export const deriveData = params => {
  return HTTP_ALB.get('data/clock/export', params)
}
